import React from 'react';
import { useBridgeState } from '@digitaz/bridge-sdk-client';
import { createAuthUrl } from '../../utils/helpers';
import { AuthWrapper, Iframe } from './styled';

interface AuthIframeProps {
  url?: string;
  closeHandler: () => void;
}

export const AuthIframe: React.FC<AuthIframeProps> = ({
  url,
  closeHandler
}) => {
  const { isWebView } = useBridgeState();
  const authByPhoneUrl = createAuthUrl();

  return (
    <AuthWrapper onClick={closeHandler} $isWebView={isWebView}>
      <Iframe
        title="Auth by phone"
        id="auth-iframe"
        src={url || authByPhoneUrl}
        onClick={e => e.stopPropagation()}
        $isWebView={isWebView}
      />
    </AuthWrapper>
  );
};
